// extracted by css-extract-rspack-plugin
export default {"root":"root-ZMkf6Z","icon":"icon-WxMzmV","spin":"spin-nshIns"};